"use client";

import { Button, cn } from "@devhop/ui";
import { ChevronRight, ScanBarcodeIcon } from "lucide-react";
import { formatPrice, type ShopCurrency } from "@/shared/lib/currency";

export type ShopPosMobileCheckoutBarProps = {
  cartSubtotalFinite: boolean;
  cartSubtotal: number;
  invoiceCurrency: ShopCurrency;
  cartLength: number;
  branchId: string | null;
  canSell: boolean;
  posSalesUnlocked: boolean;
  onFocusScan: () => void;
  onCheckout: () => void;
  onClearCart: () => void;
};

/** ແຖບຊຳລະຕິດລຸ່າ — ໂໝດງ່າຍ mobile ເທົ່ານັ້ນ */
export function ShopPosMobileCheckoutBar({
  cartSubtotalFinite,
  cartSubtotal,
  invoiceCurrency,
  cartLength,
  branchId,
  canSell,
  posSalesUnlocked,
  onFocusScan,
  onCheckout,
  onClearCart,
}: ShopPosMobileCheckoutBarProps) {
  const canCheckout =
    cartLength > 0 &&
    branchId != null &&
    canSell &&
    posSalesUnlocked &&
    cartSubtotalFinite;

  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-0 z-40 border-border border-t bg-card/95 p-3 shadow-[0_-8px_24px_-8px_color-mix(in_oklab,var(--foreground)_18%,transparent)] backdrop-blur-md",
        "pb-[max(0.75rem,env(safe-area-inset-bottom))] lg:hidden",
      )}
    >
      <div className="mx-auto flex max-w-lg items-center gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-[10px] text-muted-foreground uppercase tracking-wide">
            ລວມ ({cartLength})
          </p>
          <p className="truncate font-bold font-heading text-foreground text-xl tabular-nums">
            {cartSubtotalFinite
              ? formatPrice(cartSubtotal, invoiceCurrency)
              : "—"}
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Button
            type="button"
            size="icon"
            className="size-12 shrink-0 bg-emerald-600 text-white hover:bg-emerald-700"
            disabled={!posSalesUnlocked}
            onClick={onFocusScan}
            aria-label="ສະແກນ"
          >
            <ScanBarcodeIcon className="size-5" aria-hidden />
          </Button>
          <Button
            type="button"
            className="h-12 min-w-[5.5rem] gap-1 bg-sky-600 px-4 font-bold text-white hover:bg-sky-700"
            disabled={!canCheckout}
            onClick={onCheckout}
          >
            ຊຳລະ
            <ChevronRight className="size-4" aria-hidden />
          </Button>
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-12 px-3 font-semibold"
            disabled={cartLength === 0}
            onClick={onClearCart}
          >
            ຍົກ
          </Button>
        </div>
      </div>
    </div>
  );
}
